@if (!items) {
  <mat-spinner></mat-spinner>
}

@if (!!items && items.length === 0) {
  <span>
    No assignments
  </span>
}

@if (!!items) {
  <div
    cdkDropList
    [cdkDropListData]="items"
    (cdkDropListDropped)="drop($event)"
  >
    @for (item of items; track $index) {
      <app-action-menu-item [input]="item"
                            cdkDrag
                            [cdkDragData]="item"
                            [cdkDragDisabled]="!vehicle"
      >
      </app-action-menu-item>
    }
  </div>
}
